import { UserShortCutType } from 'components/types';
import axiosInstance from 'utils/axiosInstance';

export const UserShortCutService = async (id: string) => {
  const { data } = await axiosInstance.post<ApiResponse<UserShortCutType>>(
    `api/profile/GetProfileUser/${id}`,
  );

  return data;
};
